import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { Popup } from 'react-leaflet';

import CancelButton from './cancel-button';
import Categories from './categories';
import DeleteButton from './delete-button';
import RegionSelect from './region-select';

const useStyles = createUseStyles({
  popup: {},
  wrapper: {
    composes: ['flex-rows'],
  },
});

const MarkerPopupComponent = React.memo(({ data, isDraft, onClose }) => {
  const classes = useStyles();
  const posx = 0;
  const posy = -10;

  const onCloseHandler = useCallback(onClose, [onClose]);

  return (
    <Popup
      className={classes.popup}
      closeButton={false}
      maxWidth={170}
      minWidth={170}
      offset={[posx, posy]}
      onClose={onCloseHandler}>
      <div className={classes.wrapper}>
        <Categories data={data} />
        <RegionSelect data={data} disabled={!data.category} />
        {isDraft && <CancelButton />}
        {!isDraft && <DeleteButton id={data.id} />}
      </div>
    </Popup>
  );
});

MarkerPopupComponent.defaultProps = {
  isDraft: false,
  onClose: null,
};

MarkerPopupComponent.propTypes = {
  data: PropTypes.shape({
    category: PropTypes.string,
    id: PropTypes.string,
    latlng: PropTypes.shape(),
    region: PropTypes.string,
  }).isRequired,
  isDraft: PropTypes.bool,
  onClose: PropTypes.func,
};

MarkerPopupComponent.displayName = 'MarkerPopupComponent';

export default MarkerPopupComponent;
